export default __webpack_public_path__ + "static/media/pharmadocx_logo.3313a19f.png";